import { useState, useEffect } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Megaphone } from 'lucide-react';
import { formatDateTime } from '@/lib/formatters';
import { getActiveAnnouncements, type Announcement } from '@/services/announcementService';

export const AnnouncementBanner = () => {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const data = await getActiveAnnouncements();
        setAnnouncements(data);
      } catch (error) {
        console.error('Error fetching active announcements:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();
    
    // Refresh announcements every 5 minutes
    const interval = setInterval(fetchAnnouncements, 5 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, []);

  if (loading || announcements.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3 mb-6">
      {announcements.map((announcement) => (
        <Alert key={announcement.id} className="border-primary/20 bg-primary/5">
          <Megaphone className="h-4 w-4" />
          <AlertDescription className="space-y-2">
            <div className="flex justify-between items-start gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-2 text-sm font-medium mb-1">
                  <span>{announcement.organization?.name}</span>
                  <span className="text-foreground">•</span>
                  <span className="text-foreground">
                    {formatDateTime(announcement.created_at)}
                  </span>
                </div>
                <p className="text-sm">{announcement.comments}</p>
              </div>
            </div>
          </AlertDescription>
        </Alert>
      ))}
    </div>
  );
};